"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiquidityGaugesSDK = exports.ValidatorGaugeSDK = exports.EscrowRelockerSDK = void 0;
/* eslint-disable node/no-unpublished-import */
const chunk_1 = __importDefault(require("chunk"));
const utf8_1 = require("@project-serum/anchor/dist/cjs/utils/bytes/utf8");
const anchor = __importStar(require("@project-serum/anchor"));
const escrowGenerated = __importStar(require("../generated/target/types/escrow_relocker"));
const liquidityGaugesGenerated = __importStar(require("../generated/target/types/liquidity_gauges"));
const validator_gauge_manager_1 = require("../generated/target/types/validator_gauge_manager");
const tribeca_sdk_1 = require("@tribecahq/tribeca-sdk");
const anchor_contrib_1 = require("@saberhq/anchor-contrib");
const solana_contrib_1 = require("@saberhq/solana-contrib");
const quarry_sdk_1 = require("@quarryprotocol/quarry-sdk");
class EscrowRelockerSDK {
    constructor({ provider, escrowRelockerId = new solana_contrib_1.PublicKey('tovt1VkTE2T4caWoeFP6a2xSFoew5mNpd7FWidyyMuk'), }) {
        this.provider = new solana_contrib_1.SolanaAugmentedProvider(provider);
        const anchorProvider = (0, anchor_contrib_1.makeAnchorProvider)(provider);
        this.program = new anchor.Program(escrowGenerated.IDL, escrowRelockerId, anchorProvider);
        this.tribeca = tribeca_sdk_1.TribecaSDK.load({ provider: this.provider });
    }
}
exports.EscrowRelockerSDK = EscrowRelockerSDK;
class ValidatorGaugeSDK {
    constructor({ escrowRelocker, validatorGaugeId = new solana_contrib_1.PublicKey('va12L6Z9fa5aGJ7gxtJuQZ928nySAk5UetjcGPve3Nu'), marinadeStateAddress = new solana_contrib_1.PublicKey('8szGkuLTAux9XMgZ2vtY39jVSowEcpBfFfD8hXSEqdGC'), gaugemeisterAddress = new solana_contrib_1.PublicKey('mvgmBamY7hDWxLNGLshMoZn8nt2P8tKnKhaBeXMVajZ'), }) {
        this.program = new anchor.Program(validator_gauge_manager_1.IDL, validatorGaugeId, escrowRelocker.program.provider);
        this.escrowRelocker = escrowRelocker;
        this.marinadeStateAddress = marinadeStateAddress;
        this.gaugemeisterAddress = gaugemeisterAddress;
    }
    get provider() {
        return this.escrowRelocker.provider;
    }
    async foremanWithBump() {
        return solana_contrib_1.PublicKey.findProgramAddress([(0, utf8_1.encode)('vgm-foreman'), this.marinadeStateAddress.toBuffer()], this.program.programId);
    }
    // PDA, foreman authority
    async foreman() {
        const [address] = await this.foremanWithBump();
        return address;
    }
    restoreValidatorList(validatorList) {
        this._validatorList = validatorList;
    }
    async fetchValidatorList(forceFetch) {
        if (forceFetch || !this._validatorList) {
            const marinadeStateAccount = await this.provider.connection.getAccountInfo(this.marinadeStateAddress);
            const itemSize = Buffer.from(new Uint8Array(marinadeStateAccount === null || marinadeStateAccount === void 0 ? void 0 : marinadeStateAccount.data).slice(296, 300)).readInt32LE();
            const address = new solana_contrib_1.PublicKey(new Uint8Array(marinadeStateAccount === null || marinadeStateAccount === void 0 ? void 0 : marinadeStateAccount.data).slice(264, 296));
            const validatorListAccount = await this.provider.connection.getAccountInfo(address);
            const items = (0, chunk_1.default)(new Uint8Array(validatorListAccount === null || validatorListAccount === void 0 ? void 0 : validatorListAccount.data).slice(8), itemSize).map(uint8arr => new solana_contrib_1.PublicKey(uint8arr.slice(0, 32)));
            this._validatorList = { address, items };
        }
        return this._validatorList;
    }
}
exports.ValidatorGaugeSDK = ValidatorGaugeSDK;
class LiquidityGaugesSDK {
    constructor(escrowRelocker, liquidityGaugesId = new solana_contrib_1.PublicKey('LigadctxNRkZied3WuhX525vUhDkuhXNK5DyeijeDnh')) {
        this.escrowRelocker = escrowRelocker;
        this.program = new anchor.Program(liquidityGaugesGenerated.IDL, liquidityGaugesId, escrowRelocker.program.provider);
        this.quarry = quarry_sdk_1.QuarrySDK.load({ provider: this.provider });
    }
    get provider() {
        return this.escrowRelocker.provider;
    }
}
exports.LiquidityGaugesSDK = LiquidityGaugesSDK;
//# sourceMappingURL=sdk.js.map